import React from 'react';
import SenderMessageThreeDots from './SenderMessageThreeDots';
import ReceiverMessageThreeDots from './ReceiverMessageThreeDots';

const MessageThreeDots = (props) => {
    if (props.isSenderMessage) {
        return <SenderMessageThreeDots {...props} />;
    }
    return <ReceiverMessageThreeDots {...props} />;
};

export default MessageThreeDots;
